import type React from 'react';
import { Input, makeStyles } from '@fluentui/react-components';
import { SearchRegular } from '@fluentui/react-icons';

interface TableSearchProps {
    searchTerm: string;
    onSearch: (term: string) => void;
    placeholder?: string;
}

const useStyles = makeStyles({
    search: {
        marginBottom: '0',
        width: '100%',
    },
});

const TableSearch = ({ searchTerm, onSearch, placeholder = 'Search...' }: TableSearchProps): React.JSX.Element => {
    const classes = useStyles();

    return (
        <Input
            className={classes.search}
            placeholder={placeholder}
            type="search"
            contentBefore={<SearchRegular />}
            onChange={(_, data) => {
                onSearch(data.value);
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    onSearch(searchTerm);
                }
            }}
        />
    );
};

export default TableSearch;
